import axios from "src/lib/axios";

export const GenerateForgotPasswordOTP = async (username): Promise<any> => {
    const response = await axios.post<any>(
      `/ConfigAccount/GenerateForgotPasswordOTP?username=${username}`
    );
    return response?.data;
};

export const ValidateForgotPasswordOTP = async (otp, username, password): Promise<any> => {
    const response = await axios.post<any>(
      `/ConfigAccount/ValidateForgotPasswordOTP?otp=${otp}&username=${username}&password=${password}`
    );
    return response?.data;
};